import React, { useEffect, useMemo } from 'react';
import { KView, KText } from '@/component/RtlLayout';
import { styles } from '@/common/style';
import TextSwipper from '@/component/ScrollSwipper';
import { k18nPro } from './k18npro';
import { $k18n } from '@/common/i18n';
import { TouchableOpacity, Text, StyleSheet, ImageStyle } from 'react-native';
import IconArrowRed from '@/assets/icon/icon_arrow_right_red.png';
import { webCurrency } from '@/common/const';
import Flex from '@/component/atom/Flex';
import Button from '@/component/Button/Button';
import { logger } from '@/common/log';
import { LogShow } from '@/component/ViewVisible/ViewVisible';
import { useCoudanInfoStore } from '../coudanInfoStore';
import { PageRowData } from '@/page/detail/views/api';
import { Progress } from '@kibt/meta-ui-krn';
import Image from '@kds/image';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';

interface IProps {
    pageRawData: PageRowData;
    clickAddtoCar: () => void;
    usefulType: string;
}

const style = StyleSheet.create({"textRed":{"color":"rgba(255, 73, 6, 1)"},"cardBox":{"paddingLeft":"3.381642512077295rem","paddingVertical":15,"backgroundColor":"#fff"},"iconRight":{"width":"3.8647342995169085rem","height":"3.8647342995169085rem"}});

export default function BottomNodeCom(props: IProps) {
    const { clickAddtoCar, usefulType } = props;

    const setStore = useCoudanInfoStore().setState;

    const { checkOutDetail, discountTip, extraInfo, thresholdStage, checkoutDetailVisible } = useCoudanInfoStore(s => ({
        checkOutDetail: s.checkOutDetail,
        discountTip: s.discountTip,
        extraInfo: s.extraInfo,
        thresholdStage: s.thresholdStage,
        checkoutDetailVisible: s.checkoutDetailVisible,
    }));

    const progressInfo = useMemo(() => {
        const milestonesMap = {
            0: [100],
            1: [100],
            2: [60, 100],
            3: [50, 80, 100],
        };
        if (!Object.keys(thresholdStage).length) {
            return {
                mileStone: milestonesMap[0],
                progress: 0,
            };
        }
        const mileStone = milestonesMap[thresholdStage.totalStage];
        const modifyMileStone = [0, ...mileStone];
        console.log(
            'modifyMileStone',
            JSON.stringify(modifyMileStone),
            JSON.stringify(thresholdStage),
            modifyMileStone[thresholdStage.currentStage] +
                Math.floor(
                    ((modifyMileStone[thresholdStage.currentStage + 1] - modifyMileStone[thresholdStage.currentStage]) * thresholdStage.progress) /
                        100
                )
        );
        const progress =
            thresholdStage.currentStage >= mileStone.length
                ? 100
                : modifyMileStone[thresholdStage.currentStage] +
                  Math.floor(
                      ((modifyMileStone[thresholdStage.currentStage + 1] - modifyMileStone[thresholdStage.currentStage]) * thresholdStage.progress) /
                          100
                  );
        return {
            mileStone,
            progress,
        };
    }, [thresholdStage]);

    const onOpenCheckoutDetail = () => {
        logger.sendClick({
            action: 'DISCOUNT_AMOUNT',
            params: {
                element_type: usefulType === 'inPopup' ? 1 : 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                discount_amount: checkOutDetail?.totalDiscountAmount?.amount,
            },
        });
        setStore({ checkoutDetailVisible: !checkoutDetailVisible });
    };

    const handleClickCart = () => {
        clickAddtoCar();
        logger.sendClick({
            action: 'BOUGHT_TOGETHER_ADD_CART',
            params: {
                element_type: usefulType === 'inPopup' ? 1 : 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
            },
        });
    };

    const totalPrice = () => {
        if (checkOutDetail?.productTotalPayment?.amount) {
            return `${checkOutDetail?.productTotalPayment?.displayAmount}`;
        } else {
            return `${webCurrency}0,00`;
        }
    };

    // todo 这里得问后端格式
    const swiperText = () => {
        const textStyle = {
            border: styles({
                color: '#ff4906',
                fontWeight: '500',
            }),
            highLight: styles({
                color: '#ff4906',
                fontWeight: '500',
            }),
        };
        const getHighlightText = displayAmount => {
            return <Text style={textStyle.highLight}>{displayAmount}</Text>;
        };
        const keysArr = [];
        const replaceParams = (str: string) => {
            if (!str) return;
            return str?.replace(/\{(\w+)\}/g, (a, b) => {
                keysArr.push(b);
                return a;
            });
        };
        replaceParams(discountTip?.tip);
        if (!keysArr?.length) {
            return '';
        }
        const getParams = () => {
            const params = {};
            keysArr?.forEach((key, index) => {
                params[key] =
                    discountTip?.placeHolder?.[index]?.font === 1
                        ? getHighlightText(discountTip?.placeHolder?.[index]?.value)
                        : discountTip?.placeHolder?.[index]?.value;
            });
            return params;
        };

        const text = k18nPro({
            text: discountTip?.tip,
            params: getParams(),
        });
        return text;
    };

    useEffect(() => {
        if (extraInfo?.eventTracking?.length) {
            extraInfo.eventTracking.forEach(item => {
                const { couponId, differenceValue, elementType, isFinish, type } = item;
                logger.sendShow({
                    action: 'MARKET_TEXT',
                    params: {
                        is_finish: isFinish,
                        difference_value: differenceValue,
                        coupon_id: couponId,
                        type: type,
                        element_type: elementType,
                    },
                });
            });
        }
    }, [extraInfo]);

    const bottomNode = (
        <KView
            style={{"paddingRight":"4.5893719806763285rem","paddingLeft":"4.5893719806763285rem","paddingTop":"2.8985507246376816rem","paddingBottom":"3.8647342995169085rem","display":"flex","flexDirection":"row","justifyContent":"space-between","alignItems":"center","backgroundColor":"#fff"}}>
            <KView style={{"flex":1}}>
                <KView>
                    <KView style={{"width":"100%"}}>
                        <Progress percentage={progressInfo.progress} pivotNode={null} milestone={progressInfo.mileStone} />
                    </KView>
                    <KView style={{"display":"flex","flexDirection":"row","alignItems":"baseline","flexWrap":"wrap"}}>
                        <Text
                            style={styles({
                                fontSize: 16,
                                fontWeight: '700',
                                color: '#000',
                                marginRight: 4,
                            })}>
                            {totalPrice()}
                        </Text>
                        {checkOutDetail?.totalDiscountAmount?.amount ? (
                            <KTouchableOpacity activeOpacity={0.6} onPress={() => onOpenCheckoutDetail()}>
                                <LogShow
                                    action="DISCOUNT_AMOUNT"
                                    params={{
                                        element_type: usefulType === 'inPopup' ? 1 : 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                                        discount_amount: checkOutDetail?.totalDiscountAmount?.amount,
                                    }}>
                                    <Flex flex={'flexRowCenter'}>
                                        <Text style={[styles({ fontSize: 11, fontWeight: '500' }), style.textRed]}>
                                            {$k18n({
                                                text: '{discount} OFF',
                                                params: { discount: checkOutDetail?.totalDiscountAmount?.displayAmount },
                                            })}
                                        </Text>
                                        <Image
                                            style={
                                                styles({
                                                    width: 16,
                                                    height: 16,
                                                    transform: [{ rotate: '90deg' }],
                                                }) as ImageStyle
                                            }
                                            source={IconArrowRed}
                                        />
                                    </Flex>
                                </LogShow>
                            </KTouchableOpacity>
                        ) : null}
                    </KView>
                </KView>
            </KView>

            <LogShow
                action="BOUGHT_TOGETHER_ADD_CART"
                params={{
                    element_type: usefulType === 'inPopup' ? 1 : 0, // 0:商详页凑单楼层模块，1:商详页凑单半屏页
                }}>
                <KView style={{"marginLeft":"3.8647342995169085rem"}}>
                    <Button size="small" type="primary" allowPress={true} onPress={handleClickCart}>
                        {$k18n({ id: 'add_to_cart', text: '加入购物车' })}
                    </Button>
                </KView>
            </LogShow>
        </KView>
    );

    const divider = <KView style={{"height":"0.24154589371980678rem","backgroundColor":"rgba(242, 242, 242, 1)"}} />;

    const textTipNode = () => {
        if (usefulType === 'inPopup') {
            return (
                <KView>
                    <KView
                        style={styles({
                            // marginLeft: 19,
                            // marginRight: 19,
                            height: 37,
                            backgroundColor: '#fff6f3',
                            borderRadius: 4,
                            paddingLeft: 12,
                        })}>
                        <TextSwipper>
                            <KText
                                style={{"color":"rgba(0, 0, 0, 0.88)","fontSize":"2.8985507246376816rem","lineHeight":"8.93719806763285rem"}}>
                                {swiperText()}
                            </KText>
                        </TextSwipper>
                    </KView>
                    <KView>{divider}</KView>
                </KView>
            );
        } else {
            return (
                <KView
                    style={styles({
                        marginLeft: 19,
                        marginRight: 19,
                        height: 37,
                        backgroundColor: '#fff6f3',
                        borderRadius: 4,
                        paddingLeft: 12,
                    })}>
                    <TextSwipper>
                        <KText
                            style={{"color":"rgba(0, 0, 0, 0.88)","fontSize":"2.8985507246376816rem","lineHeight":"8.93719806763285rem"}}>
                            {swiperText()}
                        </KText>
                    </TextSwipper>
                </KView>
            );
        }
    };

    return (
        <KView
            style={styles({
                zIndex: 60,
                flexShrink: 0,
                marginTop: 12,
            })}>
            {discountTip?.tip ? textTipNode() : null}
            {bottomNode}
        </KView>
    );
}
